import { useProductBenefit } from '@/stores/products/benefits'

export const useProductsBenefits = () => {
	const { Benefits } = useProductBenefit()

	type Plans = keyof typeof Benefits
	type ObjectValues<T> = T[keyof T]
	type PlanValues = ObjectValues<typeof Benefits>
	const getBenefit = (arg: number) => {
		if (!arg) {
			return null
		}
		const selectedBenefit = (Benefits as unknown as { [id: Plans]: PlanValues })[arg]
		if (!selectedBenefit?.short_benefits) {
			console.warn('Key for benefit not found')
		}
		return {
			short: selectedBenefit?.short_benefits || null,
			all: selectedBenefit
		}
	}

	return {
		getBenefit
	}
}
